import { SETTLEMENT_OFFER_TYPES } from 'utilities/constants';

import PaymentsCalculatorCard from '../PaymentsCalculatorCard';
import { useRecoveriesState } from './recoveriesState';

const EstimatedPayments = ({ loadingQuery }) => {
  const { offer, paymentDates, paymentPlan } = useRecoveriesState();

  const isPifOffer = offer?.offerType === SETTLEMENT_OFFER_TYPES.PIF;

  return (
    <PaymentsCalculatorCard
      loadingQuery={loadingQuery}
      balanceLabel={isPifOffer ? 'Balance' : undefined}
      balance={offer?.balance?.settlementBalance}
      expirationDate={offer?.expiration}
      startDate={paymentDates?.startDate}
      cadence={paymentPlan?.cadence}
      schedule={paymentPlan?.current}
      durationMonths={paymentPlan?.planDuration ?? offer?.duration}
    />
  );
};

export default EstimatedPayments;
